import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

export default function PrimitiveAction({
  to,
  href,
  variant = "secondary",
  children,
  icon: Icon = FiArrowUpRight,
}) {
  const className = `button ${variant}`;
  const content = (
    <>
      <span>{children}</span>
      {Icon ? <Icon aria-hidden="true" /> : null}
    </>
  );

  if (href) {
    return (
      <a className={className} href={href}>
        {content}
      </a>
    );
  }

  return (
    <Link className={className} to={to}>
      {content}
    </Link>
  );
}
